import { Observable } from 'rxjs'
import { Message } from 'components/message'
import { CepService } from './cep.service'

export class CepComponent {

    constructor(formElement) {
        this.formElement = formElement;
        this.cepInputElement = this.formElement ? this.formElement.querySelector("#input-CEP") : null;
        this.inputElements;
        this.cepStream;
        this.service;
        this.alert;
        this.init()
    }

    init() {
        if(this.formElement && (this.cepInputElement)) {
            this.alert = new Message();
            this.service = new CepService();
            this.cepStream = Observable.fromEvent(this.cepInputElement, 'input');
            this.inputElements = [
                this.formElement.querySelector("#input-Endereco"),
                this.formElement.querySelector("#select-UF"),
                this.formElement.querySelector("#input-Cidade"),
                this.formElement.querySelector("#input-Bairro")
            ];
            this.cepStream
                .map(event => event.target.value)
                .debounceTime(500)
                .distinctUntilChanged()
                .filter(cep => cep.length == 8)
                .subscribe(cep => this.buscarEndereco(cep));
        }
    }

    buscarEndereco(cep) {
        return this.service
                    .buscarEnderecoPorCep(cep)
                    .subscribe(this.buscarEnderecoResponse());
    }

    buscarEnderecoResponse() {
        return {
            next: response => {
                if(response.data) {
                    const endereco = response.data[0];
                    let event = new Event('change');
                    this.inputElements.forEach((element) => {
                        const value = this.enderecoMapped(element.name, endereco);
                        if(value) {
                          element.value = value;
                          element.dispatchEvent(event);
                        }
                    })
                }
            },
            error: error => {
                this.alert.message = 'Nenhum endereço encontrado para este cep';
                this.alert.show();
                this.inputElements.forEach((element) => element.value = null)
            },
            complete: () => console.log("Complete")
        }

    }

    enderecoMapped(name, endereco) {
        if(!endereco)
            return {};

        const mapper = {
          "Endereco-beneficiario" : endereco.logradouro.nome,
          "Cidade-beneficiario" : endereco.logradouro.bairro.localidade.nome,
          "UF-beneficiario" : endereco.logradouro.bairro.localidade.siglaUf,
          "Bairro-beneficiario" : endereco.logradouro.bairro.nome
        };

        return (mapper[name]) ? mapper[name] : undefined;

      }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/cep/cep.component.js